import React from 'react';
import Box from '@mui/material/Box';

/** Pré-visualização compacta de conteúdo HTML (termos, políticas, contratos). */
export default function HtmlPreview({ html, maxHeight = 96 }) {
    return (
        <Box
            sx={{
                maxHeight,
                overflowY: 'auto',
                px: 1.5,
                py: 1,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1.5,
                bgcolor: '#FCFCFD',
                fontSize: '0.8125rem',
                lineHeight: 1.6,
                color: 'text.secondary',
                '& p': { m: 0, mb: 0.75 },
                '& ul, & ol': { pl: 2.5, my: 0.5 },
            }}
            dangerouslySetInnerHTML={{ __html: html || '' }}
        />
    );
}
